"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalCloseButton = void 0;
var react_1 = __importDefault(require("react"));
var i18n_1 = require("../../i18n");
var Button_1 = require("../Button");
var Icon_1 = require("../Icon");
var Tooltip_1 = require("../Tooltip");
exports.ModalCloseButton = function (props) {
    var onClick = props.onClick, externalStyles = props.style;
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement(Tooltip_1.Tooltip, { text: locale.modal.close },
        react_1.default.createElement(Button_1.Button, { "aria-label": locale.modal.close, size: 'small', skin: 'ghost', style: externalStyles, onClick: onClick },
            react_1.default.createElement(Icon_1.Icon, { icon: 'timesDefault' }))));
};
//# sourceMappingURL=ModalCloseButton.js.map